import { render, staticRenderFns } from "./InvoiceAddItemForm.vue?vue&type=template&id=5617620e&"
import script from "./InvoiceAddItemForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddItemForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAddItemForm.vue?vue&type=style&index=0&id=5617620e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports